var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"vw-100 vh-100 d-flex flex-row"},[(_vm.is_logged_in)?_c('main-menu'):_vm._e(),_c('div',{staticClass:"flex-grow-1",staticStyle:{"max-height":"100%","overflow-y":"auto"}},[_c('router-view')],1),_c('flash-alert')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }